import { useEffect, useState } from 'react';
import { Heart, HeartFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import {
    getCurrentUserEmail,
    loadProfile,
    PROFILE_UPDATED_EVENT,
    saveProfile,
} from '../utils/profileStorage';

function FavoriteButton({ recipeId, title, image = '', className = '', showLabel = true }) {
    const navigate = useNavigate();
    const email = getCurrentUserEmail();
    const getIsFavorite = () => loadProfile(email).favoriteRecipes
        .some((favorite) => favorite.recipeId === String(recipeId));
    const [isFavorite, setIsFavorite] = useState(getIsFavorite);

    useEffect(() => {
        const syncFavoriteState = () => setIsFavorite(getIsFavorite());
        window.addEventListener(PROFILE_UPDATED_EVENT, syncFavoriteState);
        window.addEventListener('storage', syncFavoriteState);

        return () => {
            window.removeEventListener(PROFILE_UPDATED_EVENT, syncFavoriteState);
            window.removeEventListener('storage', syncFavoriteState);
        };
    });

    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!email) {
            navigate('/login');
            return;
        }

        const profile = loadProfile(email);
        const normalizedRecipeId = String(recipeId || '').trim();
        const nextFavorites = isFavorite
            ? profile.favoriteRecipes.filter((favorite) => favorite.recipeId !== normalizedRecipeId)
            : [
                ...profile.favoriteRecipes,
                {
                    recipeId: normalizedRecipeId,
                    title: String(title || normalizedRecipeId),
                    image: String(image || ''),
                },
            ];

        saveProfile({ ...profile, favoriteRecipes: nextFavorites }, email);
        setIsFavorite(!isFavorite);
    };

    const actionLabel = !email
        ? 'Log ind for at gemme som favorit'
        : isFavorite
            ? `Fjern ${title || 'retten'} fra favoritter`
            : `Gem ${title || 'retten'} som favorit`;

    return (
        <button
            type="button"
            className={`favorite-button${isFavorite ? ' is-favorite' : ''}${showLabel ? ' has-label' : ''}${className ? ` ${className}` : ''}`}
            onClick={handleClick}
            aria-pressed={isFavorite}
            aria-label={actionLabel}
            title={actionLabel}
        >
            {isFavorite ? <HeartFill aria-hidden="true" /> : <Heart aria-hidden="true" />}
            {showLabel && <span>{isFavorite ? 'Favorit' : 'Gem favorit'}</span>}
        </button>
    );
}

export default FavoriteButton;
